import { useParams } from "react-router-dom";
import AdjustmentOfStatusContent from "../content/AdjustmentOfStatusContent";

export default function AdjustmentOfStatus() {
    const { slug } = useParams();

    return <AdjustmentOfStatusContent currentPage={slug || "home"} />;
}